<template>
  <div v-if="show" class="modal is-active">
    <div class="modal-background" @click="close()"></div>
    <div class="modal-card">
      <p v-if="loading">Loading...</p>
      <section v-else class="modal-card-body d-block br-1">

        <header class="d-flex align-items-center pb-3 space-between">
          <h2 class="fs-8">Select Tag</h2>
          <button class="delete" @click="close"></button>
        </header>

        <section>
          <span v-for="tag in searchResults" class="tag rubric-tag" :class="{ 'private-tag' : tag.group_tag }" :style="{ 'background-color': '#' + tag.color }">
            <a class="text" @click="selectTag(tag.id)">{{ tag.title }}</a>
          </span>
          <p v-if="searchResults.length == 0">No existing tags match <strong>{{ this.query }}</strong>. Create a new one!</p>
        </section>

        <div class="d-flex align-items-center pb-3 space-between">
          <input
            v-model="query"
            class="input is-medium"
            placeholder="New Tag" />

          <button class="button is-primary is-medium"
              :disabled="query === ''"
              @click="createTag()"
              type="submit">
              Create
          </button>
        </div>

      </section>
    </div>
  </div>
</template>

<script>
import store from '../store.js'

import {
  fetchTags,
  createTag,
  addTagToComment,
} from '../actionTypes'

export default {
  name: 'AddTagModal',
  props: {
    commentID: {
      type: Number,
      required: true,
    },
    videoID: {
      type: Number,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    currentTime: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      loading: true,
      query: '',
    }
  },
  async mounted () {
    document.addEventListener('keyup', this.escapeKeyPress)
    await store.dispatch(fetchTags)
    this.loading = false
  },
  beforeDestroy () {
    document.removeEventListener('keyup', this.escapeKeyPress)
  },
  computed: {
    tags () {
      return store.state.tags
    },
    searchResults () {
      return this.tags.filter(x => x.title.indexOf(this.query) !== -1)
    },
  },
  methods: {
    escapeKeyPress (event) {
      if (event.keyCode === 27) {
        this.close()
      }
    },
    close () {
      this.$emit('close')
    },
    async selectTag (id) {
      const { videoID, commentID } = this
      try {
        if (commentID === 0) {
          await store.dispatch('addComment', {
            body: '',
            start_time: this.currentTime,
            end_time: this.currentTime + 5,
            video: videoID,
            tag: id
          })
        } else {
          await store.dispatch(addTagToComment, { videoID: videoID, tagID: id, commentID: commentID })
        }
      } catch (err) {}
      this.close()
    },
    async createTag () {
      await store.dispatch(createTag, { title: this.query, create_rubric: false })
      this.query = ''
    },
  },
}

</script>

<style lang="scss" scoped>

.tag {
  padding: 1.1rem;
  margin: .2rem;
}

.text {
  font-size: 1.5rem;
  color: #fff;
}

.private-tag {
  border-left: 10px solid orange;
}


</style>



// WEBPACK FOOTER //
// AddTagModal.vue?438f9cd2